import * as actions from './actions';


export const toggleAndSaveColumns = ({ columns, columnToUpdate }) => (dispatch) => {
  const updatedColumns = columns.set(columnToUpdate, !columns.get(columnToUpdate));
  dispatch(actions.toggleColumn(columnToUpdate));
  const arrayColumns = updatedColumns.entrySeq().map(([name, visible]) => ({
    name,
    visible,
  }));

  dispatch(actions.putColumns({ columns: arrayColumns }));
};
